<template>
  <modal :showModal="showModal" id="modal-success" @close="close">
    <template slot="modal-header">
      <h5 class="bold">Witamy w Programie Partnerskim Punkta</h5>
    </template>

    <template slot="modal-body">
      <img src="../assets/success-icon.jpg">
      <h5>Jakie są następne kroki?</h5>
      <p>Przejdź do swojego konta, skopiuj indywidualny link partnerski i zacznij promować ubezpieczenia Punkta.</p>
    </template>

    <template slot="modal-footer">
      <button class="btn btn-large" @click="close">
        Przejdź do panelu
      </button>
    </template>
  </modal>
</template>

<script>
  import Loader from '@/components/loader'
  import Modal from '@/components/modal'
  export default {
    props: ['tranche', 'showModal'],
    components: { Loader, Modal },
    methods: {
      close () {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/stylesheets/variables';
  @import 'src/components/modal';

  #modal-success {
    .modal-container .close {
      display: none;
    }

    img {
      max-width: 100%;
    }

    .modal-footer .btn {
      width: auto;
    }

    @media #{$small-and-down} {
      .modal-wrapper {
        display: block;
      }

      .modal-container {
        height: 100vh;
        width: 100vw;
        border-radius: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// modalSuccessAccountDetails.vue?5a3d53b9